import PropTypes from 'prop-types'
import React, { createContext, useState } from 'react'

export const HeaderContext = createContext({
  currentPath: null,
  isEducatorInstrument: false,
  setCurrentPath: () => {},
})

export const HeaderContextProvider = ({ children, isEducatorInstrumentParam }) => {
  const [currentPath, _setCurrentPath] = useState(null)
  const [isEducatorInstrument, _setIsEducatorInstrument] = useState(isEducatorInstrumentParam)

  const setCurrentPath = path => {
    _setCurrentPath(path)
  }

  const setIsEducatorInstrument = path => {
    _setIsEducatorInstrument(path)
  }

  const value = {
    currentPath,
    isEducatorInstrument,
    setCurrentPath,
    setIsEducatorInstrument,
  }

  return <HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>
}

export default HeaderContextProvider

HeaderContextProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
}
